module.exports = "<div layout=\"column\">\n    <div ui-view=\"content\" flex=\"80\"></div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/user/userView.html
// module id = 518
// module chunks = 0